import { atom } from 'recoil';

type UiStateType = {
  menuOpen: boolean;
  iaWaitlist: boolean;
};

export const uiState = atom<UiStateType>({
  key: 'ui_state',
  default: {
    menuOpen: true,
    iaWaitlist: true,
  },
  effects: [
    ({ onSet, setSelf }) => {
      const uiState = localStorage.getItem('ui_state');
      if (uiState) {
        setSelf(JSON.parse(uiState));
      }

      onSet(newValue => {
        localStorage.setItem('ui_state', JSON.stringify(newValue));
      });
    },
  ],
});

type UserWithMetadata = {
  metadata?: {
    showAcademy?: boolean;
  };
};

/**
 * Updates the waitlist status based on user metadata
 * @param user The user object containing metadata
 * @returns A function that can be used to update the UI state
 */
export const checkAcademyAccess =
  (user: UserWithMetadata | null) =>
  (currentState: UiStateType): UiStateType => {
    const hasAcademyAccess = user?.metadata?.showAcademy === true;

    return {
      ...currentState,
      iaWaitlist: !hasAcademyAccess,
    };
  };
